module.exports = __webpack_public_path__ + "static/profile-9cfbbb525f4eed9749305b59e25eda5e.png";